import { cva } from 'class-variance-authority'

export const $button = cva(
  'disabled:cursor-not-allowed disabled:opacity-50 cursor-default leading-4 inline-flex items-center font-medium focus-visible:outline outline-1 outline-offset-2 gap-1 outline-dark-control-base',
  {
    variants: {
      intent: {
        primary:
          'bg-dark-control-base text-button-label border-dark-control-base dark:[&:not(button)]:hover:bg-dark-control-highlight dark:[&:is(button)]:enabled:hover:bg-dark-control-highlight dark:[&:is(button)]:enabled:hover:border-dark-control-highlight dark:[&:not(button)]:hover:border-dark-control-highlight [&:not(button)]:hover:bg-invert-control-highlight [&:is(button)]:enabled:hover:bg-invert-control-highlight [&:is(button)]:enabled:hover:border-invert-control-highlight [&:not(button)]:hover:border-invert-control-highlight',
        secondary:
          'bg-dark-base border-dark-border-solid border [&:is(button)]:enabled:hover:bg-dark-shade [&:not(button)]:hover:bg-dark-shade text-dark-dim dark:bg-dark-shade-hover dark:[&:is(button)]:enabled:hover:bg-dark-elevated dark:[&:not(button)]:hover:bg-dark-elevated dark:[&:is(button)]:enabled:hover:border-dark-elevated dark:[&:not(button)]:hover:border-dark-elevated',
        tertiary:
          'bg-red border-red border [&:is(button)]:enabled:hover:bg-red-hover [&:is(button)]:enabled:hover:border-bg-red-hover [&:not(button)]:hover:bg-red-hover [&:not(button)]:hover:border-bg-red-hover text-button-label',
        select:
          // secondary but with a softer hover
          'bg-dark-base border-dark-border-solid border [&:is(button)]:enabled:hover:bg-dark-shade [&:not(button)]:hover:bg-dark-shade text-dark-dim dark:bg-dark-shade dark:[&:is(button)]:enabled:hover:bg-dark-shade-hover dark:[&:not(button)]:hover:bg-dark-shade-hover dark:[&:is(button)]:enabled:hover:border-dark-shade-hover dark:[&:not(button)]:hover:border-dark-shade-hover',
      },
      size: {
        xs: 'text-xs min-h-[20px] h-auto px-2',
        small: 'text-xs min-h-[26px] h-auto px-3',
        medium: 'text-sm h-7 px-3',
        large: 'text-sm h-8 px-4',
        xl: 'text-base h-[38px] px-3.5',
      },
      align: {
        center: 'text-center justify-center',
        left: 'text-left',
      },
      iconPaddingLeft: {
        true: 'pl-2',
      },
      pointer: {
        true: '[&:is(button)]:enabled:!cursor-pointer [&:not(button)]:!cursor-pointer',
      },
      iconSide: {
        left: 'flex-row',
        right: 'flex-row-reverse',
      },
      tracking: {
        tight: 'tracking-tight',
        none: 'tracking-normal',
      },
      radius: {
        default: 'rounded-4xl',
        md: 'rounded-md !px-2',
        icon: 'rounded',
      },
    },
    compoundVariants: [
      { size: 'large', iconPaddingLeft: true, class: 'pr-3.5 pl-4' },
      // Force one line on fixed height sizes
      {
        size: ['large', 'xl', 'medium'],
        class: 'line-clamp-1',
      },
      {
        intent: 'select',
        class: '!gap-x-1.5 !text-xs',
      },
    ],
    defaultVariants: {
      align: 'center',
      intent: 'primary',
      size: 'medium',
      tracking: 'tight',
      radius: 'default',
    },
  }
)
